/* MJade Home Parity Shim gate v7 (session36)
   London fixed-text row is clipped by the exact edges that cover it on Main:
   previous section's bottom edge (hero) from above, This Season's top edge from below.
   Disappearance position = identical to Main by construction. All widths. */
(function(){
  function boot(){
    var sec=document.querySelector('[id$="__media_with_text_d6yHfT"]');
    var row=document.getElementById('custom-richtext-row-text_VF9AEw');
    if(!sec||!row) return;
    var ts=document.querySelector('[id$="16359278676808bea5"]');
    var prev=sec.previousElementSibling;
    var tick=false;
    function apply(){
      tick=false;
      var vh=innerHeight;
      var ct=prev?Math.max(0,prev.getBoundingClientRect().bottom):0;
      var cb=ts?Math.max(0,vh-ts.getBoundingClientRect().top):0;
      if(ct+cb>=vh){
        row.style.visibility='hidden';
        row.style.clipPath='';
      }else{
        row.style.visibility='';
        row.style.clipPath=(ct>0||cb>0)?('inset('+ct+'px 0 '+cb+'px 0)'):'';
      }
    }
    function onScroll(){ if(!tick){ tick=true; requestAnimationFrame(apply); } }
    addEventListener('scroll',onScroll,{passive:true});
    addEventListener('resize',onScroll,{passive:true});
    apply();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
